module.exports = __webpack_public_path__ + "img/brand-places.ee9ee6f9.svg";